import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { createCustomElement } from '@angular/elements';

import { AuthMenuModule } from './components/auth-menu/auth-menu.module';
import { AuthMenuComponent } from './components/auth-menu/components/auth-menu/auth-menu.component';
import { DriverEventsModule } from './components/driver-events/driver-events.module';
import { DriverEventsComponent } from './components/driver-events/components/driver-events/driver-events.component';
import { LanguageSwitchButtonModule } from './components/language-switch-button/language-switch-button.module';
import { LanguageSwitchButtonComponent } from './components/language-switch-button/components/language-switch-button/language-switch-button.component';
import { LoginCallbackComponent } from './components/auth-menu/components/login-callback/login-callback.component';
import { LogoutCallbackComponent } from './components/auth-menu/components/logout-callback/logout-callback.component';


/** 
 * WE CAN'T USE NGX-BOOTSTRAP IN STANDALONE COMPONENTS ATM
 * SO WE HAVE TO USE MODULE WRAPPER - AppModule - TO DEFINE DEPENDENCIES FROM NGX-BOOTSTRAP
 */
@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        AuthMenuModule,
        LanguageSwitchButtonModule,
        DriverEventsModule
    ],
    declarations: [
    ],
    providers: [
    ],
})
export class AppModule {
    constructor(private injector: Injector) { }

    async ngDoBootstrap() {
        const languageSwitchButtonElement = createCustomElement(LanguageSwitchButtonComponent, { injector: this.injector });
        customElements.define('jr-language-switch-button', languageSwitchButtonElement);

        const driverEventsComponent = createCustomElement(DriverEventsComponent, { injector: this.injector });
        customElements.define('jr-driver-events', driverEventsComponent);

        const authMenuComponent = createCustomElement(AuthMenuComponent, { injector: this.injector });
        customElements.define('jr-auth-menu', authMenuComponent);

        const loginCallbackComponent = createCustomElement(LoginCallbackComponent, { injector: this.injector });
        customElements.define('jr-login-callback', loginCallbackComponent);
        
        const logoutCallbackComponent = createCustomElement(LogoutCallbackComponent, { injector: this.injector });
        customElements.define('jr-logout-callback', logoutCallbackComponent);
    }
}
